import { KnownCodableConceptCode } from "@intocare/datatypes/lib/concept";

import { FollowUpPlanEdit } from "./follow-up-plan-edit";

export interface FollowUpPlanEditDto {
	id: string;
	title: string;
	problemStatement: string;
	careThemes: KnownCodableConceptCode[];
	version: number;
}

export const convertToFollowUpPlanEditDto = (formData: FollowUpPlanEdit): FollowUpPlanEditDto => {
	const { careTheme, ...rest } = formData;
	return {
		...rest,
		careThemes: [careTheme],
	};
};
